import { flatten } from 'shared/lang'
import { getSafeRedirect } from '../../shared/security/redirects'

/**
 * Given a route config (a react-router <Route> component, that could have
 * one or more children), create a flat array of actual paths supported.
 *
 * @param  {[type]} route [description]
 * @param  {String} path  [description]
 * @return {[type]}       [description]
 */

export function gatherRoutes (route, path = '', paths = []) {
  const children = route.props.children
  const multipleChildren = children && Array.isArray(children)
  const singleChild = children && !multipleChildren

  const _path = route.props.path
  const sep = _path && _path[0] === '/' ? '' : '/'
  const newPath = _path ? `${path}${sep}${_path}` : path

  if (!children) {
    return paths.concat(newPath)
  }

  if (singleChild) {
    return gatherRoutes(children, newPath, paths)
  }

  if (multipleChildren) {
    return children.map(child => gatherRoutes(child, newPath, paths))
  }
}

/**
 * Return a flattened list of route paths supported by routes.jsx
 *
 * @param  {Object} routeConfig - element exported by routes.jsx
 * @return {Array}
 */
export function listRoutes (routeConfig) {
  return flatten(gatherRoutes(routeConfig))
}

/**
 * Given an array of strings, representing supported paths (react-router
 * routes), determine if 'path' matches one of them. Supports dynamic segments
 * like ':userId'.
 *
 * @param  {String} path  - the path we'd like to test
 * @param  {[type]} paths - list of strings, representing valid react-router paths
 */
export function supportedRoute (path, paths) {
  // exclude the catch all, obviously
  const _paths = paths.filter(_path => _path !== '/*')
  return _paths.find(_path => {
    const pattern = _path.replace(/:\w+/, '\\w+')
    const regexp = new RegExp(`\^${pattern}`)
    window.regexp = regexp
    return regexp.test(path)
  })
}

export function goToNext (next, defaultPath) {
  const protocol = window.location.protocol
  const host = window.location.host
  const safeRedirect = getSafeRedirect(next, protocol, host, defaultPath)
  window.location.href = safeRedirect
}
